import { useEffect, useState } from 'react'

const useMedia = (media) => {
  const [matches, setMatches] = useState(false)

  const handleMediaChange = (media) => {
    setMatches(media?.matches || false)
  }

  useEffect(() => {
    const matchMedia = window.matchMedia(media)

    handleMediaChange(matchMedia)

    matchMedia.addEventListener('change', handleMediaChange)

    return () => {
      matchMedia.removeEventListener('change', handleMediaChange)
    }
  }, [])

  return matches
}

export default useMedia
